/**
 * Created by Ning Jiang on 4/29/2019.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {PPGameMode} from "../gamemode/PPGameMode";
import {IPixiesVsPiratesParsedServerData} from "../server/parseddata/IPixiesVsPiratesParsedServerData";
import {PixiesVsPiratesParsedGameData} from "../server/parseddata/PixiesVsPiratesParsedGameData";
import {XWaysIndicatorView} from "./XWaysIndicatorView";
import {BattleEvent} from "../reelstoppresentation/battlecollect/BattleEvent";
import {TimelineLite} from "gsap";

export class XWaysIndicatorController extends BaseController {

    private static _fsTotalWays:number = 3 * 6 * 6 * 6 * 6 * 3;
    private static _defaultTotalWays:number = 729;
    private _view:XWaysIndicatorView;
    private _gameAreaSize:number[];
    private _totalXWays:number;
    private _totalXWaysEnteringFS:number;
    private _nextMode:GameMode;
    private _mode:GameMode;

    constructor() {
        super();

        this._view = new XWaysIndicatorView();
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onGameReady());
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeMode(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeStart());
        EventHandler.addEventListener(this, BattleEvent.UPDATE_XWAYS, (event:GameEvent) => this.animateXways());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onAllReelsStop());
    }

    private onServerDataParsed(data:IPixiesVsPiratesParsedServerData):void {
        this._gameAreaSize = data.gameAreaSize.concat();
        this._totalXWays = this.getTotalXWays(data.gameAreaSize);
        if(data instanceof PixiesVsPiratesParsedGameData) {
            this._totalXWaysEnteringFS = this.getTotalXWays(data.gameAreaSizeEnteringFreespin);
        } else {
            this._totalXWaysEnteringFS = 729;
        }
        this._nextMode = data.nextMode;
        this._mode = data.mode;
    }

    private getTotalXWays(size:number[]):number {
        let total:number = 1;
        size.forEach((n:number) => {
            total *= n;
        });
        return total;
    }

    private onGameReady():void {
        this._view.updateTotalWays(this._totalXWays, false);
    }

    private animateXways():void{
        if(this._mode === PPGameMode.FREESPIN_PICK) {
            const xWaysTimeline:TimelineLite = new TimelineLite({onComplete: () => {
                    EventHandler.dispatchEvent(new GameEvent(BattleEvent.XWAYS_UPDATED));
                }});
            xWaysTimeline.add(this._view.playTotalWaysPoof(true));
        }
    }

    private onBeforeStart():void {
        if(this._nextMode === GameMode.FREESPIN) {
            return;
        }
        this._totalXWays = XWaysIndicatorController._defaultTotalWays;
        this._view.updateTotalWays(this._totalXWays, false);
    }

    private onAllReelsStop():void {
        if(this._mode === GameMode.FREESPIN) {
            return;
        }
        this._view.updateTotalWays(this._totalXWays, true);
    }

    private onChangeMode(data:IGameModeChangedData):void {
        this._view.updateTotalWays(data.newMode === GameMode.FREESPIN ? XWaysIndicatorController._fsTotalWays : this._totalXWaysEnteringFS, false);
    }
}